import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {defineMessages, injectIntl, intlShape} from 'react-intl';

import GreenFlag from '../green-flag/green-flag.jsx';
import StopAll from '../stop-all/stop-all.jsx';
import TurboMode from '../turbo-mode/turbo-mode.jsx';
import cameraIcon from '../../lib/libraries/extensions/videoSensing/video-sensing-small.svg';

import styles from './controls.css';

const messages = defineMessages({
    goTitle: {
        id: 'gui.controls.go',
        defaultMessage: 'Go',
        description: 'Green flag button title'
    },
    stopTitle: {
        id: 'gui.controls.stop',
        defaultMessage: 'Stop',
        description: 'Stop button title'
    },
    cameraTitle: {
        id: 'gui.controls.camera',
        defaultMessage: 'Kamera',
        description: 'Knap til at tænde eller slukke kameraet'
    }
});

const Controls = function (props) {
    const {
        active,
        className,
        intl,
        isCameraOn,
        onCameraToggleClick,
        onGreenFlagClick,
        onStopAllClick,
        turbo,
        ...componentProps
    } = props;
    return (
        <div
            className={classNames(styles.controlsContainer, className)}
            {...componentProps}
        >
            <GreenFlag
                active={active}
                title={intl.formatMessage(messages.goTitle)}
                onClick={onGreenFlagClick}
            />
            <StopAll
                active={active}
                title={intl.formatMessage(messages.stopTitle)}
                onClick={onStopAllClick}
            />
            <img
                className={classNames(styles.cameraToggle, {
                    [styles.isActive]: isCameraOn
                })}
                draggable={false}
                src={cameraIcon}
                title={intl.formatMessage(messages.cameraTitle)}
                onClick={onCameraToggleClick}
            />
            {turbo ? (
                <TurboMode />
            ) : null}
        </div>
    );
};

Controls.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    intl: intlShape.isRequired,
    isCameraOn: PropTypes.bool,
    onCameraToggleClick: PropTypes.func.isRequired,
    onGreenFlagClick: PropTypes.func.isRequired,
    onStopAllClick: PropTypes.func.isRequired,
    turbo: PropTypes.bool
};

Controls.defaultProps = {
    active: false,
    isCameraOn: false,
    turbo: false
};

export default injectIntl(Controls);
